/**
 * Analytics event logging
 * Simple stub that can be connected to GA, PostHog, or other analytics
 */

export function logEvent(eventName, payload = {}) {
  // Log to console in development
  console.log('[Analytics Event]', eventName, payload);
  
  // TODO: Wire to actual analytics service
  // Example for Google Analytics:
  // if (window.gtag) {
  //   window.gtag('event', eventName, payload);
  // }
  
  // Example for PostHog:
  // if (window.posthog) {
  //   window.posthog.capture(eventName, payload);
  // }
  
  // Store events for debugging
  if (typeof window !== 'undefined') {
    window.__analytics_events = window.__analytics_events || [];
    window.__analytics_events.push({
      name: eventName,
      payload,
      timestamp: new Date().toISOString()
    });
  }
}

/**
 * Get all logged events (for debugging)
 */
export function getAnalyticsEvents() {
  return window.__analytics_events || [];
}

/**
 * Clear logged events
 */
export function clearAnalyticsEvents() {
  if (typeof window !== 'undefined') {
    window.__analytics_events = [];
  }
}
